import React from 'react';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/46114651766972:1';
export function FinalCTASection() {
  return <section className="relative bg-garden-dark py-20 px-4 sm:px-6 lg:px-8 text-center text-white overflow-hidden" data-id="element-23">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSIvPjwvc3ZnPg==')] opacity-50" data-id="element-24"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-garden-medium/40 via-transparent to-transparent pointer-events-none" data-id="element-25"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-26">
        <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-black mb-6 leading-tight drop-shadow-lg" data-id="element-27">
          🌱 Tener tu huerta puede ser más simple
        </h2>
        <p className="text-xl sm:text-2xl text-white/90 font-medium mb-8 max-w-2xl mx-auto" data-id="element-28">
          No necesitas más intentos. Necesitas un sistema.
        </p>
        <p className="text-2xl sm:text-3xl font-black text-earth-light mb-10 tracking-wide" data-id="element-29">
          👉 Empieza hoy con EL MANUAL DEL JARDINERO.
        </p>

        <div className="relative inline-block group" data-id="element-30">
          <div className="absolute -inset-1 bg-white rounded-full blur opacity-30 group-hover:opacity-60 transition duration-500 animate-pulse-glow" data-id="element-31"></div>
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="relative inline-block bg-white hover:bg-neutral-bg text-garden-dark font-black text-xl sm:text-2xl py-5 px-10 sm:px-16 rounded-full shadow-2xl transform transition-all duration-300 hover:-translate-y-1" data-id="element-32">
            SÍ, QUIERO ACCEDER AHORA
          </a>
        </div>
      </div>
    </section>;
}